// Escapes a value for safe use in HTML text and (double-quoted) attributes,
// eg. Ort names like '"Unsere Bergstätten" Buchenberg - ...' in data-name="...".
export function escapeHtml(value) {
  const safeValue = value === null || value === undefined ? '' : value;
  return String(safeValue)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
